import * as React from "react"

const MOBILE_BREAKPOINT = 768
// Tailwind `lg` breakpoint — used to match `lg:hidden` / `hidden lg:block` in CSS
const LG_BREAKPOINT = 1024

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

/**
 * Returns true when the viewport is below Tailwind's `lg` breakpoint (1024px).
 * Use this to mirror `lg:hidden` / `hidden lg:block` visibility in React so
 * components only mount once instead of being CSS-hidden duplicates.
 */
export function useIsBelowLg() {
  const [below, setBelow] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${LG_BREAKPOINT - 1}px)`)
    const onChange = () => setBelow(window.innerWidth < LG_BREAKPOINT)
    mql.addEventListener("change", onChange)
    setBelow(window.innerWidth < LG_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!below
}
